import { useEffect } from 'react';
import { getAnalytics, isSupported } from 'firebase/analytics';
import Main from './components/Origin/main';
import { app } from './config/firebase';

function App() {
  useEffect(() => {
    isSupported()
      .then((ok) => ok && getAnalytics(app))
      .catch(() => {});
  }, []);

  return <Main />;
}

export default App;
